import { useEffect, useReducer, useCallback } from 'react';
import { noop } from '@adsk/alloy-react-helpers';
var ACTIONS = /*#__PURE__*/function (ACTIONS) {
  ACTIONS["RESET"] = "RESET";
  ACTIONS["ADD_DATA"] = "ADD_DATA";
  ACTIONS["UPDATE_ENTITY"] = "UPDATE_ENTITY";
  ACTIONS["REMOVE_ENTITY_ID"] = "REMOVE_ENTITY_ID";
  return ACTIONS;
}(ACTIONS || {});
const createDataReducer = () => (state, action) => {
  switch (action.type) {
    case ACTIONS.RESET:
      return [];
    case ACTIONS.ADD_DATA:
      return [...state, ...action.payload];
    case ACTIONS.UPDATE_ENTITY:
      return state.map(e => e.id === action.payload.id ? action.payload : e);
    case ACTIONS.REMOVE_ENTITY_ID:
      return state.filter(e => e.id !== action.payload);
    default:
      throw new Error();
  }
};

/**
 * This hook aggregates data from both BE and local state.
 * It is updated whenever we get data from BE, or when user adds or removes data.
 *
 * @param dataFromBE
 * @param onDataChange
 * @returns {{allData: array, addData: function, removeEntityById: function, clearData: function}}
 */
export default (function (dataFromBE) {
  let onDataChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  const reducer = createDataReducer();
  const [data, dispatch] = useReducer(reducer, []);
  useEffect(() => {
    if (dataFromBE && dataFromBE.length) {
      dispatch({
        type: ACTIONS.RESET
      });
      dispatch({
        type: ACTIONS.ADD_DATA,
        payload: dataFromBE
      });
    }
  }, [dataFromBE]);
  const addData = useCallback(newData => {
    onDataChange();
    dispatch({
      type: ACTIONS.ADD_DATA,
      payload: newData
    });
  }, [onDataChange]);
  const updateEntity = useCallback(entity => {
    onDataChange();
    dispatch({
      type: ACTIONS.UPDATE_ENTITY,
      payload: entity
    });
  }, [onDataChange]);
  const removeEntityById = useCallback(id => {
    onDataChange();
    dispatch({
      type: ACTIONS.REMOVE_ENTITY_ID,
      payload: id
    });
  }, [onDataChange]);
  const clearData = useCallback(() => {
    dispatch({
      type: ACTIONS.RESET
    });
  }, []);
  return {
    data,
    addData,
    updateEntity,
    removeEntityById,
    clearData
  };
});
//# sourceMappingURL=useLocalStateData.js.map